import { ArrowDown, ArrowRight } from "lucide-react";
import { cn } from "@design-lab/shared/lib/tailwindcss";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { ExpertEditFeatures } from "./ExpertEditFeatures";

const cards = [
  {
    title: "Original Upload",
    imageUrl: remoteImageStaticUrl("2/DesignLabPrintPerfectBefore.png", { w: 275, h: 275 }),
    alt: "Before Design Services",
    bgColor: "bg-slate-100",
    sampleMessage:
      'Please remove the pink background, change the ribbon color to blue, remove freckles. Change "Its a girl!" to "Emma"',
    changes: null
  },
  {
    title: "Designer Perfected",
    imageUrl: remoteImageStaticUrl("2/DesignLabPrintPerfectAfter.png", { w: 275, h: 275 }),
    alt: "After Design Services",
    bgColor: "",
    sampleMessage: null,
    changes: ["Ribbon color changed", "Freckles removed", "Background removed", "Text changed"]
  }
];

export function DesignServiceInfo() {
  const { isDesktop } = useResponsive();
  return (
    <>
      {!isDesktop && <ExpertEditFeatures />}
      <div className="space-y-4">
        <div className="flex items-start gap-6">
          <div className="relative flex flex-wrap justify-center gap-6">
            {cards.map((card, idx) => (
              <div key={idx}>
                <div
                  className={cn(
                    "flex w-full flex-col items-center gap-2 rounded-lg p-3 lg:w-[260px]",
                    card.bgColor
                  )}
                >
                  <h2 className="text-center text-lg font-bold">{card.title}</h2>
                  <img
                    src={card.imageUrl}
                    alt={card.alt}
                    className="w-full max-w-[220px] rounded-lg border border-gray-200 object-cover p-px shadow-lg"
                  />
                  {card.sampleMessage && (
                    <div className="w-full space-y-1">
                      <p className="text-sm font-bold text-gray-800">Sample message to designer:</p>
                      <p className="text-sm leading-tight text-gray-600">{card.sampleMessage}</p>
                    </div>
                  )}
                  {card.changes && card.changes.length > 0 && (
                    <div className="flex w-full flex-wrap gap-1 lg:flex-none">
                      {card.changes.map((change, index) => (
                        <div className="flex items-center gap-2" key={change}>
                          <div className="text-background flex size-5 shrink-0 items-center justify-center rounded-full bg-green-600 text-sm">
                            {index + 1}
                          </div>
                          <p className="text-sm font-medium text-gray-800">{change}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {idx === 0 && (
                  <div className="absolute left-1/2 top-[calc(50%-12px)] z-10 -translate-x-1/2">
                    <div className="bg-foreground flex size-10 items-center justify-center rounded-full shadow-md">
                      <ArrowDown
                        className="text-background block size-6 lg:hidden"
                        strokeWidth={2.5}
                      />
                      <ArrowRight
                        className="text-background hidden size-6 lg:block"
                        strokeWidth={2.5}
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {isDesktop && <ExpertEditFeatures />}
      </div>
    </>
  );
}
